import { ReactNode } from "react";
import { Header } from "./Header";

export function TaskPaneLayout({ children }: { readonly children: ReactNode }) {
  return (
    <div className="flex flex-col h-screen" style={{ background: "var(--color-background)" }}>
      <Header />
      <main className="flex-1 overflow-y-auto p-4">{children}</main>
    </div>
  );
}
